import { StatementOfAccessibilityPage } from "./StatementOfAccessibilityPage";

export function StatementOfAccessibility(){
    return (
        <StatementOfAccessibilityPage/>
    );
}